import { c as _c } from "react/compiler-runtime";
import { AspectRatio, Button, Heading, VStack } from '@chakra-ui/react';
import { getTrackPathPrefix } from '@src/components/sco/Education/ContentTrackContext';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ContentTrack } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { useHover } from '@uidotdev/usehooks';
type ContentTrackCardSmallProps = {
  contentTrack: ContentTrack;
  vertical?: boolean;
  bgDir?: any;
  number?: string;
};
export const ContentTrackCardSmall = props => {
  const $ = _c(24);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const [hoverRef, isHovering] = useHover();
  let t0;
  if ($[0] !== props.contentTrack) {
    t0 = getTrackPathPrefix(props.contentTrack);
    $[0] = props.contentTrack;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = `/${t0}/${props.contentTrack.slug}`;
  const t2 = isHovering ? "" : `url('${props.contentTrack?.featuredImage?.url}')`;
  const t3 = props.contentTrack.title;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      transform: "scale(1.025)"
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = `${props.contentTrack.color?.hex}50`;
  const t6 = isHovering ? 1 : 0;
  let t7;
  if ($[3] !== getBreakpointValue) {
    t7 = getBreakpointValue(["sm", "sm", "md", "lg", "lg"]);
    $[3] = getBreakpointValue;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== props.contentTrack.title || $[6] !== t7) {
    t8 = <VStack gap={2}><Heading fontWeight="700" lineHeight="shorter" size={t7} textAlign="center">{props.contentTrack.title}</Heading></VStack>;
    $[5] = props.contentTrack.title;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = `${props.contentTrack.color?.hex}`;
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ChevronRightIcon />;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== t9) {
    t11 = <Button as="span" bgColor={t9} size="sm">Start Course{t10}</Button>;
    $[9] = t9;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t11 || $[12] !== t5 || $[13] !== t6 || $[14] !== t8) {
    t12 = <VStack bgColor={t5} borderRadius={10} gap={6} height="full" opacity={t6} padding={6} transition="all 250ms ease-out" width="full">{t8}{t11}</VStack>;
    $[11] = t11;
    $[12] = t5;
    $[13] = t6;
    $[14] = t8;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== hoverRef || $[17] !== props.contentTrack.title || $[18] !== t12 || $[19] !== t2) {
    t13 = <AspectRatio ref={hoverRef} background={t2} bgPos="50% 50%" bgRepeat="no-repeat" bgSize="contain" filter="drop-shadow(0 0 4px rgba(0,0,0,0.25))" ratio={0.715} title={t3} transition="all 250ms ease-out" _hover={t4}>{t12}</AspectRatio>;
    $[16] = hoverRef;
    $[17] = props.contentTrack.title;
    $[18] = t12;
    $[19] = t2;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t1 || $[22] !== t13) {
    t14 = <NextLink href={t1}>{t13}</NextLink>;
    $[21] = t1;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
};
ContentTrackCardSmall.fragments = {
  ContentTrack: () => gql`
    fragment _ on ContentTrack {
      id
      title
      slug
      type
      shortDescription
      terms {
        id
        name
      }
      featuredImage {
        id
        url(transformation: { image: { resize: { fit: max, width: 1000 } } })
      }
      terms {
        id
        name
      }
    }
  `
};